import { Component } from '@angular/core';
import { ProductMenuFooterComponent } from '../product-menu-footer.component';

@Component({
  selector: 'app-empty-menu-footer',
  templateUrl: './empty-menu-footer.component.html',
  standalone: false
})
export class EmptyMenuFooterComponent extends ProductMenuFooterComponent {}
